import Tour from '@/services/onboarding'

const investorListTour = new Tour([
  {
    title: 'Investor Search',
    text: 'Type to search for an investor',
    selector: '.search bottom',
  },
  {
    title: 'Investor List',
    text: 'Browse the list of investors',
    selector: '.table top',
  },
])

export default investorListTour
